// modal okna
function modal() {
  // zavření modal okna
  $('.js-modal-close').on('click', function (event) {
    event.preventDefault();
    $(this).closest('.modal').removeClass('is-open');
    $('.order__menu-top').removeClass('order__menu-top--hidescroll-2');
    $('body').removeClass('is-unscrollable');
  });

  // otevření okna
  $('.js-modal-open').on('click', function () {
    // zjištění ID okna z atributu rel
    let modalName = $(this).attr('href');

    // otevření okna
    $(modalName).addClass('is-open');
    $('body').addClass('is-unscrollable');
  });

  // modal uvnitř objednávkového procesu
  $('.js-modal-open-order').on('click', function () {
    $('.order__menu-top').addClass('order__menu-top--hidescroll-2');
  });

  // zavření okna kliknutím na pozadí
  $('.modal').on('click', function (event) {
    event.preventDefault();
    $(this).removeClass('is-open');
    $('body').removeClass('is-unscrollable');
  });

  // zamezení zavření po kliknutí na tělo modalu
  $('.modal__body').on('click', function (event) {
    event.stopPropagation();
  });
}

$(function () {
  var path = window.location.href;

  if (path.indexOf('#login') >= 0) {
    $('#login').addClass('is-open');
    $('body').addClass('is-unscrollable');
  }

  if (path.indexOf('?reset-password-token=') >= 0) {
    $('.modal-reset-password').addClass('js-active');
    $('body').addClass('js-freeze');
    $('body').removeClass('js-menu-opened');
    $('.nav--check').prop('checked', false);
  }
});
